import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { Container, Grid, Typography, useTheme, } from "@mui/material";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
const TopHeader = ({ openPopup, translate }) => {
    const theme = useTheme();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    return (_jsx(Container, { disableGutters: true, sx: { maxWidth: "100% !important", padding: "16px 0px 16px 16px" }, children: _jsxs(Grid, { container: true, spacing: 2, sx: {
                alignItems: "center"
            }, children: [_jsx(Grid, { size: {
                        xs: 12,
                        sm: 6,
                        md: 6
                    }, children: _jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary }, children: translate("Users") }) }), _jsx(Grid, { sx: { textAlign: "right" }, size: {
                        xs: 12,
                        sm: 6,
                        md: 6
                    } })] }) }));
};
export default TopHeader;
